<div [formGroup]="group">
  <div class="d-flex" [class.is-invalid]="getField().invalid && getField().dirty">
    <py-checkbox [class.rounded]="rounded" [showLabel]="!!rightLabel" [showLeftLabel]="!!leftLabel">
      <input
        type="checkbox"
        [id]="fieldName"
        [formControlName]="fieldName"
        [class.invalid]="getField().invalid && getField().dirty"
      />
      <span *ngIf="!!leftLabel" slot="left-label" [ngClass]="customLabelClass" [innerHTML]="leftLabel"></span>
      <span *ngIf="!!rightLabel" slot="label" [ngClass]="customLabelClass">
        <span [innerHTML]="rightLabel"></span>
        <cx-generic-link *ngIf="rightLabelIcon" (click)="onClick()">
          <i nz-icon [nzType]="rightLabelIcon" nzTheme="outline"></i>
        </cx-generic-link>
      </span>
    </py-checkbox>
  </div>
  <div [id]="'errors-' + fieldName" class="invalid-feedback">
    {{ errors() | inputError }}
  </div>
</div>
